exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vlSelected > div > h3[data-v-70bb8d5a] {\n  font-weight: bold;\n}\n.vlImageRow > div[data-v-70bb8d5a] {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n.vlImageRow > div > div[data-v-70bb8d5a]:first-child {\n  background-size: cover;\n  background-position: center;\n  flex-shrink: 0;\n}\n.vlImageRow > div > div[data-v-70bb8d5a]:last-child {\n  flex: 1;\n}", ""]);

// exports
